import * as React from 'react';
import { z } from 'zod';
import { useController } from 'react-hook-form';

import { TextBlockType } from '__generated-api__';
import { EmptyBlock, TextBlock } from 'my-account/validations/project';
import InputField from 'components/Form/InputField';

const TocPageFields: React.VFC<{ currentPagePreview: number }> = ({ currentPagePreview }) => {
  const text = useController<{ block: z.infer<typeof TextBlock> | z.infer<typeof EmptyBlock> | undefined }, 'block'>({
    name: `latest.pages.${currentPagePreview}.blocks.0` as unknown as 'block',
  });

  React.useEffect(() => {
    if (!text.field.value) {
      text.field.onChange({
        id: null,
        type: TextBlockType.Text,
        content: {
          content: '',
        },
      });
    }
  }, [text.field]);

  if (!text.field.value) {
    return null;
  }

  return (
    <div className="u-mb-spacer-base-large">
      <InputField label="Title" name={`latest.pages.${currentPagePreview}.blocks.0.content.content`} elStyle="fill" />
    </div>
  );
};

export default TocPageFields;
